export interface WizardStepperItem {
  /** Stable wizard step id used by navigation logic. */
  id: number;
  label: string;
  /** 1-based visible position when steps are hidden (defaults to `id`). */
  displayIndex?: number;
}

export const MUNILY_WIZARD_STEPPER_DEFAULTS = {
  allowNavigation: true,
} as const;
